import React, { Component } from 'react';
import { ToolTipTrigger } from './ToolTipTrigger';
import { ToolTipInfo } from './ToolTipInfo';

class ToolTip extends Component {
	state = {
		open: false,
	}
	handleTriggerClick = (e) => {
		e.preventDefault();
		this.setState({open: !this.state.open});
	}
	render() {
		const open = this.state.open;
		const info = this.props.info;
		const title = this.props.title;
		return (
			<span className="tooltip-container">
				<ToolTipTrigger 
					handleClick={this.handleTriggerClick} />
				{open ? (
					<ToolTipInfo
						handleClick={this.handleTriggerClick} 
						title={title}
						info={info} />
				) : (false)}
			</span>
		)
	}
}

export default ToolTip;


// WEBPACK FOOTER //
// ./src/components/ToolTip/ToolTip.js